import { DatePicker as SeiueDatePicker } from '@seiue/ui'
import { DateTypeEnum } from 'packages/sdks-next/growp'
import React from 'react'

import { CustomerDatePickerProps } from './types'
import { momentToString, stringToMoment } from './utils'

/**
 * Form DatePicker封装
 * @param param - 参数
 * @param param.disabled - 是否禁用
 * @param param.dateType - 时间显示格式类型
 * @param param.value - 非受控表单组件无需手动传入此参数
 * @param param.onChange - 非受控表单组件无需手动传此参数
 * @returns React.ReactNode
 */
export const DatePicker: React.FC<CustomerDatePickerProps> = ({
  dateType,
  value,
  onChange,
  ...rest
}) => {
  return (
    <SeiueDatePicker
      allowClear={true}
      {...rest}
      value={stringToMoment(value, dateType)}
      onChange={(v) => onChange && onChange(momentToString(v, dateType))}
      showTime={dateType === DateTypeEnum.Time}
    />
  )
}
